<script setup lang="ts">
import RadioListItem from '@/components/shared/RadioListItem.vue';
import { IDepartment } from '@/interfaces';

interface Props {
  departments: IDepartment[];
  selectedDepartment?: IDepartment;
  bottomMargin?: string;
}

withDefaults(defineProps<Props>(), {
  bottomMargin: 'bottom-[124px]',
});

const emit = defineEmits(['department-selected']);
</script>

<template>
  <div
    class="z-[80] w-[700px] left-1/2 -translate-x-1/2 absolute rounded-2xl p-6 shadow-large bg-neutral-0"
    :class="bottomMargin"
    @click.stop
  >
    <p class="h700 text-center mb-6">
      {{ $t('global.selectDepartment') }}
    </p>

    <div
      v-if="departments.length"
      class="options max-h-[636px] pr-4"
      :class="{
        'overflow-y-auto': departments.length > 4,
      }"
    >
      <RadioListItem
        v-for="(department, i) in departments"
        :key="i"
        :option="department"
        :is-selected="department.id === selectedDepartment?.id"
        @option-selected="emit('department-selected', department)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: block;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
  background-color: #eee;
}

::-webkit-scrollbar-thumb {
  border-radius: 12px;
  background-color: #a4a4a4;
}
</style>
